import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { PreviewItemModel } from '../../file-preview.component';
import { BasePreviewComponent } from '../base-preview/base-preview.component';
import { Config } from '@environments/config';
import { ErrorType } from '@shared/services/stream-content.service';

@Component({
  selector: 'image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewComponent extends BasePreviewComponent implements OnDestroy {
  @ViewChild('imgRef') imgRef: ElementRef;

  srcUrl: string;

  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    if (!this.modelValidated()) {
      return;
    }

    this.streamContentService
      .streamBlobSrc(model.item.srcUrl, Config.preview.files.maxSizeInMB)
      .then(async (url: string) => {
        this.srcUrl = url;
        this.finishLoad();
      })
      .catch((err: ErrorType) => {
        this.errorType = err;
        this.finishLoad();
      });
  }

  get model(): PreviewItemModel {
    return this._model;
  }

  set prevWidth(val: number) {
    this._width = val;
    this.scaleEl(this.imgRef?.nativeElement, val);
  }

  get prevWidth() {
    return this._width;
  }

  ngOnDestroy() {
    if (this.imgRef) {
      this.imgRef.nativeElement.src = '';
    }
    super.ngOnDestroy();
  }
}
